// Only covers image types we need for binary diff previews. If broader
// coverage is needed, consider replacing this with the `mime` package
// (wraps mime-db) which provides a full extension→MIME mapping.
const MIME_TYPES: Record<string, string> = {
    ".png": "image/png",
    ".jpg": "image/jpeg",
    ".jpeg": "image/jpeg",
    ".gif": "image/gif",
    ".bmp": "image/bmp",
    ".webp": "image/webp",
    ".ico": "image/x-icon",
    ".svg": "image/svg+xml",
    ".avif": "image/avif",
    ".tif": "image/tiff",
    ".tiff": "image/tiff",
    ".apng": "image/apng",
    ".jxl": "image/jxl",
};

/**
 * Returns the MIME type for the given file path based on its extension,
 * or null if the extension is not recognised. Currently limited to image types.
 */
export function mimeTypeFromPath(path: string): string | null {
    const dot = path.lastIndexOf(".");
    if (dot === -1) return null;
    return MIME_TYPES[path.slice(dot).toLowerCase()] ?? null;
}

export function isImageFile(path: string): boolean {
    return mimeTypeFromPath(path) !== null;
}
